import {types} from 'mobx-state-tree';

const PromoteListingImageModel = types.model('PromoteListingImage', {
  id: types.identifierNumber,
  url: types.maybe(types.string),
  caption: types.maybe(types.string)
});

const PromoteListingModel = types.model('PromoteListing', {
  id: types.identifierNumber,
  name: types.string,
  internalName: types.maybe(types.string),
  address: types.string,
  latitude: types.number,
  longitude: types.number,
  bedrooms: types.number,
  countryCode: types.string,
  commission: types.string,
  requirements: types.maybe(types.string),
  state: types.string,
  userId: types.number,
  images: types.array(PromoteListingImageModel)
});

export type PromoteListingModelType = typeof PromoteListingModel.Type;
export default PromoteListingModel;



// WEBPACK FOOTER //
// ./src/models/PromoteListingModel/PromoteListingModel.ts